<template>
    <div class="default-wrapper">
      <p class="tips">{{ msg }}</p>
    </div>
  </template>
  
  <script type="text/javascript">
  export default {
    props: {
      msg: {
        type: String,
        default: "没有更多数据了～"
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .default-wrapper {
    text-align: center;
    height: 35px;
  }
  .tips {
    font-size: 12px;
    line-height: 35px;
    color: #999;
  }
  </style>
  